<template>
  <div class="fired-page">
    <section class="fired-header">
      <div class="fired-title">
        <span class="fired-kicker">签约管理</span>
        <h1>红人解约</h1>
        <p>检索签约红人，选择解约类型并记录解约日期</p>
      </div>
      <div class="fired-status-card">
        <span>当前红人</span>
        <strong>{{ selectedArtistName }}</strong>
      </div>
    </section>

    <section class="fired-content">
      <div class="fired-layout">
        <section class="fired-panel fired-form-panel">
          <div class="panel-header">
            <div>
              <h2>解约信息</h2>
              <p>请确认红人、解约类型和解约时间</p>
            </div>
          </div>

          <el-form ref="elForm" class="fired-form" size="small" :model="formData" :rules="rules" label-position="top">
            <el-form-item label="红人" prop="nickname">
              <span
                v-if="hasPresetArtist"
                class="fired-control preset-artist-display">
                <i class="el-icon-user"></i>
                {{ formData.nickname }}
              </span>
              <el-autocomplete
                v-else
                class="fired-control"
                v-model="formData.nickname"
                :fetch-suggestions="searchUser"
                placeholder="输入红人昵称检索"
                @select="handleSelectQuery"
                @clear="clearSelected"
                clearable>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="解约类型" prop="fired_type">
              <el-select class="fired-control" v-model="formData.fired_type" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="解约时间" prop="fired_at">
              <el-date-picker
                class="fired-control"
                v-model="formData.fired_at"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button
                type="primary"
                icon="el-icon-check"
                @click="submitForm"
                v-if="userPermissions.indexOf('sign_fired_page') > -1">
                确认解约
              </el-button>
            </el-form-item>
          </el-form>
        </section>

        <aside class="fired-panel fired-summary-panel">
          <div class="panel-header">
            <div>
              <h2>确认概览</h2>
              <p>提交前核对本次解约信息</p>
            </div>
          </div>
          <div class="summary-list">
            <div class="summary-item">
              <span>红人昵称</span>
              <strong>{{ selectedArtistName }}</strong>
            </div>
            <div class="summary-item">
              <span>解约类型</span>
              <strong>{{ selectedFiredType }}</strong>
            </div>
            <div class="summary-item">
              <span>解约时间</span>
              <strong>{{ selectedFiredDate }}</strong>
            </div>
            <div class="summary-warning">
              <i class="el-icon-warning-outline"></i>
              <span>确认解约后，该红人的签约状态将按提交信息更新。</span>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SignFired",
  components: {  },
  props: [],
  data() {
    return {
      formData: {
        id: undefined,
        nickname: undefined,
        fired_at: undefined,
        fired_type:undefined,
      },
      typeOptions:[
        {value:'1',label:'到期解约'},
        {value:'2',label:'提前解约'},
      ],
      rules: {
        nickname: [{
          required: true,
          message: '请检索并选择解约红人',
          trigger: 'change'
        }],
        fired_type: [{
          required:true,
          message:'请选择解约类型',
          trigger:'change'
        }],
        fired_at: [{
          required: true,
          message: '请选择解约时间',
          trigger: 'change'
        }],
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    hasPresetArtist() {
      return Boolean(this.$route.query.artist_id || this.$route.query.id)
    },
    selectedArtistName() {
      return this.formData.nickname || '未选择'
    },
    selectedFiredType() {
      const option = this.typeOptions.find(item => item.value === this.formData.fired_type)
      return option ? option.label : '未选择'
    },
    selectedFiredDate() {
      return this.formData.fired_at || '未选择'
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.initRouteArtist()
      },
      deep: true
    }
  },
  created() {
    this.initRouteArtist()
  },
  mounted() {
  },
  methods: {
    initRouteArtist() {
      const query = this.$route.query || {}
      const artistId = query.artist_id || query.id
      if (!artistId) {
        this.formData.id = null
        this.formData.nickname = null
        return
      }

      this.formData.id = artistId
      this.formData.nickname = query.nickname || ''
    },
    submitForm() {
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        // TODO 提交表单
        this.$confirm('此操作将[确认解约]操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.commitSave()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });


      })
    },
    async commitSave() {
      const info = await this.$api.signInfoFired({ id: this.formData.id, fired_at: this.formData.fired_at, fired_type:this.formData.fired_type })
      if (info === 'ok') {
        this.$notify.success("解约成功")
      }
    },
    resetForm() {
      this.$refs['elForm'].resetFields()
    },
    // 搜索用户,qs请求参数，cb回调函数，详见组件用法
    async searchUser(qs, cb) {
      const list = await this.$api.searchSignInfo(qs)
      cb(list)
    },
    // 处理搜索结果的选中
    handleSelectQuery(item) {
      this.formData.id = item.id
      this.formData.group_id = item.group_id
      this.formData.nickname = item.nickname
      if (this.formData.id) {
        this.$refs['elForm'].validateField('id')
      }
    },
    clearSelected() {
      this.formData.id = null
    },
    // 选择分组
    selectGroup(val) {
      this.formData.group_id = val
    },
  }
}

</script>
<style scoped>
.fired-page {
  min-height: 100%;
  padding: 14px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow: auto;
}

.fired-header,
.fired-panel {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.fired-header {
  min-height: 104px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.fired-title {
  min-width: 0;
}

.fired-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.fired-title h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.fired-title p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.fired-status-card {
  min-width: 220px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.fired-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.fired-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fired-content {
  margin-top: 12px;
}

.fired-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 12px;
  align-items: stretch;
}

.fired-panel {
  min-width: 0;
  overflow: hidden;
}

.panel-header {
  min-height: 64px;
  padding: 14px 18px;
  border-bottom: 1px solid #edf1f6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.panel-header p {
  margin: 2px 0 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.fired-form {
  padding: 18px;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(180px, 240px) minmax(180px, 240px) auto;
  gap: 16px;
  align-items: end;
}

.fired-form ::v-deep .el-form-item {
  margin-bottom: 0;
}

.fired-form ::v-deep .el-form-item__label {
  padding-bottom: 7px;
  color: #667085;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.fired-control {
  width: 100%;
}

.preset-artist-display {
  min-height: 32px;
  padding: 0 12px;
  color: #263142;
  background: #f8fafc;
  border: 1px solid #dbe3ee;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
}

.preset-artist-display i {
  margin-right: 8px;
  color: #ff3176;
  font-size: 15px;
}

.fired-control ::v-deep .el-input,
.fired-control ::v-deep .el-select,
.fired-control ::v-deep .el-autocomplete {
  width: 100%;
}

.submit-item {
  min-width: 120px;
}

.submit-item ::v-deep .el-button {
  width: 118px;
}

.summary-list {
  padding: 8px 18px 18px;
}

.summary-item {
  padding: 14px 0;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.summary-item span {
  color: #7a8494;
  font-size: 13px;
  flex: 0 0 auto;
}

.summary-item strong {
  min-width: 0;
  color: #263142;
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-warning {
  margin-top: 14px;
  padding: 10px 12px;
  color: #7a4b00;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 18px;
}

.summary-warning i {
  margin-top: 2px;
  color: #f59e0b;
  flex: 0 0 auto;
}

@media (max-width: 1180px) {
  .fired-layout {
    grid-template-columns: 1fr;
  }

  .fired-form {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media (max-width: 760px) {
  .fired-page {
    padding: 12px;
  }

  .fired-header {
    padding: 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .fired-status-card {
    width: 100%;
    min-width: 0;
  }

  .fired-form {
    grid-template-columns: 1fr;
  }
}
</style>
